import classNames from 'classnames';
import * as React from 'react';

import styles from './ElementsRow.module.scss';

export interface RowProps {
  className?: string;
  children?: React.ReactNode;
}

const ElementsRow: React.FunctionComponent<RowProps> = ({ children, className }) => {
  return <div className={classNames(styles.elementsRow, className)}>{children}</div>;
};

export default ElementsRow;
